export function loadAiLiveChat() {
  if (typeof document === 'undefined') return;

  const scriptId = 'ai-search-next-script';
  const src =
    'https://static.crazysales.com.au/shop-helper-kit/live-chat-next.js' +
    '?width=440px&height=100vh&top=0&right=0' +
    `&_t=${Date.now()}`;
  const oldScript = document.getElementById(scriptId);

  if (oldScript) oldScript.remove();

  const aiLiveChatJs = document.createElement('script');
  aiLiveChatJs.id = scriptId;
  aiLiveChatJs.src = src;
  aiLiveChatJs.async = true;
  aiLiveChatJs.onload = () => console.log('[ai-search] Script injected successfully:', src);
  aiLiveChatJs.onerror = (error) => console.error('[ai-search] Script injection failed:', src, error);

  document.head.appendChild(aiLiveChatJs);
}
